import { TableComissaoProdutor } from "./components/table/TableComissaoProdutor";

export const PageComissaoProdutor = () => {
  return (
    <TableComissaoProdutor />
  );
};
